import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { BankAccountDataService } from '../../services/bank-account-data.service';
import { UtilitiesService } from '../../services/utilities.service';
import { ConsentsService } from '../../services/consents.service';
import { HttpService } from '../../services/http.service';
import { CommonService } from 'src/app/services/common/common.service';
import { DynamicItem } from 'src/app/models/dynamicItem';
import { PopupConsentPinComponent } from '../popups/popup-consent-pin/popup-consent-pin.component';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss']
})

/**
 * This component is used in the dashboard to show linked bank accounts and consents attached to them.
 * Please check dashboard component for more info
 */
export class AccountListComponent implements OnInit {
  @Input()
  accountData;
  @Input()
  revokeOption;
  bankLogos: any;
  activeAccount:boolean;
  activeAccountIndex:string;

  statusRevoked = "REVOKED";
  statusPaused = "PAUSED";
  statusActive = "ACTIVE";

  activeConsentsCount;
  activeOrPausedConsentsCount; //This is to enable revoke All option

  showPopupFlag = false;
  popupData: any;
  actionObject: any;

  @Output() refreshDashboardData = new EventEmitter();
  
  constructor(
    private bankService: BankAccountDataService,
    private consentService: ConsentsService,
    private util:UtilitiesService,
    private http: HttpService,
    private commonService: CommonService,
    private route: Router) {
  }

  ngOnInit() {
    this.getActiveBankAccount();
    this.getBankLogos();
    this.getUpdatedStatus()
  }

  getBankLogos() {
    if(this.bankLogos == undefined || this.bankLogos == null) {
      this.bankService.getBanksLogos().subscribe((res) => {
        if (res != undefined) {
          this.bankLogos = res;
        }
      });
    }
  }
  setActiveBankAccount(){
    if(this.activeAccountIndex==this.accountData['userAccountID']){
      this.util.setActiveBankPanel(null);
    }else{
    this.util.setActiveBankPanel(this.accountData['userAccountID']);
    }
  }
  getActiveBankAccount(){
    this.util.getActiveBankPanel().subscribe(res=>{
      this.activeAccountIndex=res;
    });
  }
  delinkAccount(pin){
    let option = {
      type: 'post',
      url: 'accountDelink',
      includeUserSession: true,
      data: {
        consentPin: pin,
        accountIds : this.actionObject.consents
      }
    }
    this.http.makeHttpRequest(option).subscribe((res) => {
      if (res["errorMessage"] == 'ConsentPinMisMatch') {
        this.showGlobalPopup("Consent Pin Mismatch");
      } else {
        this.closePopup();
        this.refreshDashboardData.emit();
      }
    });;
  }
  consentRevoke(pin) {
    this.actionObject.consentPin = pin
    console.log(this.actionObject," consent update ins 009 005...")
    this.consentService.consentUpdate(this.actionObject, (res) => {
      if (res["errorMessage"] == 'ConsentPinMisMatch') {
        this.showGlobalPopup("Consent Pin Mismatch");
        return;
      } else {
        this.closePopup();
        this.refreshDashboardData.emit();
      }
    });
  }

  consentUpdate(pin) {
    this.actionObject.consentPin = pin
    console.log(this.actionObject," this.actionObject this.actionObject this.actionObject 001");
    console.log(this.actionObject," consent update ins 009 002...")
    this.consentService.consentUpdate(this.actionObject, (res) => {
      if (res["errorMessage"] == 'ConsentPinMisMatch') {
        this.showGlobalPopup("Consent Pin Mismatch");
        return;
      } else {
        this.closePopup();
        this.refreshDashboardData.emit();
      }
    });
  }

  consentRevokeAll() {
    var toBeRevoked = this.accountData.consentArtefacts.filter(consent => {
      return consent.status != this.statusRevoked;
    });
    var consentIds = toBeRevoked.map(consent => {
      return consent.consentArtefactId;
    });
    
    this.actionObject = {
      consents : consentIds,
      status: this.statusRevoked
    }
    this.showpopup();
  }

  getUpdatedStatus() {
    this.activeConsentsCount = 0;
    this.activeOrPausedConsentsCount = 0;

    this.accountData.consentArtefacts.forEach(consent => {
      if(consent.status == this.statusActive) {
        this.activeConsentsCount++;
      }
      if(consent.status == this.statusActive || consent.status == this.statusPaused) {
        this.activeOrPausedConsentsCount++;
      }
    });
  }


  /**
   * Following code is duplicated in ConsentConfirmation screen
   * But we need to pass context callbacks to work
   * Need to relook this once
   */

    /**
   * @param event 
   * This will be triggered on consent update event emitter triggered or click
   * this will intiates the consent update by asking for pin
   * Actual update method will be triggered by popup on confirm
   * 
   * Following methods are for same, initiateConsentUpdate, initiateConsentRevoke, initiateAccountDelink
   */
  initiateConsentUpdate(event) {
    this.actionObject = {
      consents : [event.consentId],
      status: event.status,
      accounts: event.accounts
    }
    this.showpopup()
  }

  initiateConsentRevoke(event) {
    this.actionObject = {
      consents : event.consentIds,
      status: this.statusRevoked,
      accounts: event.accounts
    }
    this.showpopup()
  }

  initiateAccountDelink(accountId) {
    this.actionObject = {
      consents : [accountId], //Here it is account id not an consent id
      status: "Delink"
    }
    this.showpopup()
  }


  /**
   * This method will take of consent action popups
   * Before calling this method we are updating 
   * actionObject with status and consents
   * 
   * Popup content and callbacks will be assigned based on status
   * On successfull confirm from popup binded events will be triggered
   */
  showpopup() {
   /* if(this.activeOrPausedConsentsCount == 0) {
      this.delinkAccount(null);
      return;  //if account dont have any linked consetns no need to ask for pin
    }*/

    let eventType = this.actionObject.status;
    let popuptext = this.consentService.getPopupContent(eventType);
    
    switch(eventType) {
      case this.statusRevoked:
        popuptext.successCallback = this.consentRevoke.bind(this);
        break;
      case this.statusPaused:
      case this.statusActive:
        popuptext.successCallback = this.consentUpdate.bind(this);
        break;
      case "Delink":
        popuptext.successCallback = this.delinkAccount.bind(this);
        break;
    }
    popuptext.cancelCallback = this.closePopup.bind(this);

    this.popupData = new DynamicItem(PopupConsentPinComponent, popuptext);
    this.showPopupFlag = true;
  }

  /**
   * To hide Popup, we are changing ngIf to false.
   */
  closePopup() {
    this.showPopupFlag = false;
  }

  /**
   * To build and show global message popup
   * @param body popup body message
   * @param heading popup heading message
   */
  showGlobalPopup(body: string, heading?: string) {
    let popuptext = {
      heading: heading || "OnemoneyAA",
      body: body
    }

    this.commonService.showGlobalMessage(popuptext);
  }
}
 
